import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ faqs }) {
  const list = (faqs || []).filter((f) => f.published !== false).sort((a, b) => (a.order || 0) - (b.order || 0));
  return (
    <section id="faq" className="py-24 sm:py-32 bg-slate-50">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-500">FAQ</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight text-[#0B132B]">Questions? Answered.</h2>
        </div>
        <Accordion type="single" collapsible className="mt-10">
          {list.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-b border-slate-200">
              <AccordionTrigger className="text-left font-display text-lg text-[#0B132B] hover:no-underline">{f.question}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
